import { useTranslation } from "react-i18next";
import type { FlowCellProps } from "./types";
import {
  useChatPanelActions,
  useRecapDataContext,
} from "../../contexts/RecapContext";
import { derivePreOrderSource } from "../../utils/sourceUtils";

export function PartnerCell({ flow }: FlowCellProps) {
  const { t } = useTranslation();
  // Stable actions slice — PartnerCell only opens the panel imperatively
  // on click. Per-product view renders one PartnerCell per flow row, so
  // skipping panel-state re-renders saves a lot of work.
  const chatPanelActions = useChatPanelActions();
  // data.preOrders (date-scoped, unfiltered) is broader than filteredPreOrders
  // — the partner name still resolves when the PO is hidden by status/search
  // filters, and we can also derive the chat source for openPanel.
  const data = useRecapDataContext();

  const preOrder = data.preOrdersById.get(flow.pre_order_id as string) ?? null;
  const partner = preOrder?.partner ?? null;

  return (
    <div
      className="text-sm font-medium text-gray-900 truncate cursor-pointer"
      onClick={() =>
        chatPanelActions.openPanel(
          flow.pre_order_id,
          preOrder
            ? derivePreOrderSource(preOrder, {
                // Swap the PO's trigger-user chat id to the viewer's own
                // seat for shared-group conversations — keeps PartnerCell
                // aligned with the inline source-button popover.
                currentUserId: data.user.id,
                viewerWhatsappChats: data.viewerWhatsappChats,
                viewerSmsChats: data.viewerSmsChats,
              })
            : undefined,
        )
      }
    >
      {partner?.name || t("ordersRecap.noPartner")}
    </div>
  );
}
